import { useCallback } from 'react';

import { useAppDispatch } from '../../../app/store';

import { setIsMessageError } from '../../../app/store';
import { immediateToast } from 'utils/toast';

const useTicketHelpers = () => {
    const dispatch = useAppDispatch();

    const fileSizeLimit = 10;

    const handleSendErrorFile = useCallback(
        (invalidFiles: Array<{ file: File; type: 'size' | 'format' }>) => {
            invalidFiles?.forEach((invalidFile) => {
                immediateToast('error', {
                    timeout: 3000,
                    message:
                        invalidFile.type === 'format'
                            ? `فرمت فایل «${invalidFile.file.name}» مجاز نیست.`
                            : `حجم فایل «${invalidFile.file.name}» نباید بیشتر از ${fileSizeLimit} مگابایت باشد.`,
                });
            });
        },
        [],
    );

    const handleIsMessageError = (isError: boolean) => {
        dispatch(setIsMessageError(isError));
    };

    return {
        onSendErrorFile: handleSendErrorFile,
        onIsMessageError: handleIsMessageError,
        fileSizeLimit,
    };
};

export default useTicketHelpers;
